import {
  useGetReportsViolationTypesQuery,
  useGetStatusesQuery,
  useGetReportRejectionReasonQuery,
  useGetTagsQuery,
  useGetSeriousOffenseReasonsTypeQuery,
} from "features/api/reports/reportsSlice";
import { useDispatch } from "react-redux";
import {
  setSearchKeyword,
  setselectedRole,
  setPageNumberSearch,
} from "store/slices/reportsSlice";
import { useParams } from "react-router-dom";
import { useAppSelector } from "./reduxToolkit";

export const useReports = () => {
  const { data: statuses } = useGetStatusesQuery();
  const { data: tags } = useGetTagsQuery();
  const { data: rejectionReasons } = useGetReportRejectionReasonQuery();
  const { data: reportsViolationsTypes } = useGetReportsViolationTypesQuery();
  const { data: seriousOffenseReasonsType } =
    useGetSeriousOffenseReasonsTypeQuery();

  const dispatch = useDispatch();

  const getStatusById = (statusId: number) => {
    const reportStatus = getAllStatuses().length
      ? getAllStatuses().find((status) => status.id === statusId)
      : null;

    return reportStatus;
  };

  const getAllStatuses = () => {
    const allReportsStatuses = statuses
      ? [...statuses.inProgress, ...statuses.followups]
      : [];

    return allReportsStatuses;
  };

  const stateReportId = useAppSelector(
    (state) => state.reportsSliceReducer.reportId
  );

  const { reportId } = useParams();

  const getReportId = () => {
    return stateReportId || reportId;
  };

  return {
    reportsViolationsTypes,
    seriousOffenseReasonsType,
    getStatusById,
    getAllStatuses,
    reportStatuses: statuses,
    tags,
    rejectionReasons,
    searchKeyword: useAppSelector(
      (state) => state.reportsSliceReducer.searchKeyword
    ),
    setSearchKeyword: (keyword) => dispatch(setSearchKeyword(keyword)),
    selectedRole: useAppSelector((state) => {
      return state.reportsSliceReducer.selectedRole;
    }),
    setselectedRole: (value) => dispatch(setselectedRole(value)),
    getReportId,
    getPageNumber: useAppSelector((state) => {
      return state.reportsSliceReducer.pageNumberSearch;
    }),
    setPageNumber: (page) => dispatch(setPageNumberSearch(page)),
  };
};
